module.exports = __webpack_public_path__ + "static/img/noimage.466d1819.png";